<app-ng-dynamic-breadcrumb [bgColor]="breadcrumbConfig.bgColor"
                           [fontColor]="isBreadcrumbLoading ? 'transparent' : breadcrumbConfig.fontColor"
                           [fontSize]="breadcrumbConfig.fontSize"
                           [lastLinkColor]="isBreadcrumbLoading ? 'transparent' : breadcrumbConfig.lastLinkColor"
                           [style.background-color]="breadcrumbConfig.bgColor"
                           [style.color]="isBreadcrumbLoading ? 'transparent' : breadcrumbConfig.fontColor"
                           class="pl-2 pt-2">
</app-ng-dynamic-breadcrumb>